export const brand = 'Garrett John Law'

export const navLinks = [
  { href: '/', label: 'Home' },
  { href: '/resume', label: 'Résumé' },
  { href: '/portfolio', label: 'Portfolio' },
  { href: '/fugue-lab', label: 'Fugue Lab' },
  { href: '/about', label: 'About' },
  { href: '/blog', label: 'Blog' },
]

export const contactCTA = { href: '/contact', label: 'Contact' }
